module.exports = __webpack_public_path__ + "img/game-icon.fb3a926a.svg";